module.exports = __webpack_public_path__ + "static/media/carryOn.3c0ddd97.png";